'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.to = to;
exports.jumpTo = jumpTo;
exports.back = back;
exports.transformLink = transformLink;

var _bridge = require('@beastshop/bridge');

var _bridge2 = _interopRequireDefault(_bridge);

var _util = require('../lib/util');

var _appWeb = require('./link/app-web');

var _miniprogram = require('./link/miniprogram');

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MP_WEB = 'miniprogram';
var APP = 'app';
var M_WEB = 'm-web';
var WX_WEB = 'wx-web';

var MP_WEBVIEW_CONTIANER = '/pages-two/webview-container/index';
var QUERY_REFERRER_NAME = '_mini_ref';
var QUERY_PAGE_NAME = '_mini_page';

function to(_ref) {
  var link = _ref.link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$shopId = _ref.shopId,
      shopId = _ref$shopId === undefined ? '' : _ref$shopId,
      mpType = _ref.mpType;

  _util.adapter.invoke(function () {
    transformLink({ link: link, title: title, shopId: shopId, mpType: mpType }).then(function (_ref2) {
      var url = _ref2.url,
          type = _ref2.type;

      console.log('---final:', url, type);
      url && jumpTo({
        url: url,
        mpType: type ? type : mpType
      });
    });
  });
}

function jumpTo(_ref3) {
  var url = _ref3.url,
      _ref3$mpType = _ref3.mpType,
      mpType = _ref3$mpType === undefined ? 'navigate' : _ref3$mpType;

  _util.adapter.invoke(function () {
    switch (_util.adapter.env) {
      case APP:
        _bridge2.default.open({ url: url });
        break;
      case MP_WEB:
        _wxJumpTo({ url: url, mpType: mpType });
        break;
      case M_WEB:
        window.location.href = url;
        break;
      case WX_WEB:
        window.location.href = url;
        break;
      default:
    }
  });
}

function back() {
  _util.adapter.invoke(function () {
    switch (_util.adapter.env) {
      case APP:
        _bridge2.default.closeWindow();
        break;
      case MP_WEB:
        wx.miniProgram.navigateBack();
        break;
      case M_WEB:
        history.go(-1);
        break;
      case WX_WEB:
        history.go(-1);
        break;
      default:
        history.go(-1);
    }
  });
}

function transformLink(_ref4) {
  var link = _ref4.link,
      title = _ref4.title,
      shopId = _ref4.shopId,
      mpType = _ref4.mpType;

  var resolve = void 0;
  var promise = new _promise2.default(function (res, rej) {
    resolve = res;
  });
  _util.adapter.invoke(function () {
    switch (_util.adapter.env) {
      case MP_WEB:
        if (mpType === 'web') {
          resolve((0, _appWeb.transformLink)({ link: link, title: title, shopId: shopId }));
        } else {
          resolve((0, _miniprogram.transformLink)({ link: link, title: title, shopId: shopId }));
        }
        break;
      default:
        resolve((0, _appWeb.transformLink)({ link: link, title: title, shopId: shopId }));
    }
  });
  return promise;
}

function _wxJumpTo(_ref5) {
  var url = _ref5.url,
      mpType = _ref5.mpType;

  var mp = wx.miniProgram;

  var query = {};
  var referrer = window.location.origin + window.location.pathname;
  query[QUERY_REFERRER_NAME] = referrer;
  if (mpType !== 'web') {
    url = addQeury(url, query);
  }

  switch (mpType) {
    case 'web':
      mp.navigateTo({
        url: MP_WEBVIEW_CONTIANER + '?' + QUERY_PAGE_NAME + '=' + btoa(url) + '&' + QUERY_REFERRER_NAME + '=' + btoa(referrer)
      });
      break;
    case 'navigate':
      mp.navigateTo({ url: url });
      break;
    case 'tab':
      mp.switchTab({ url: url });
      break;
    case 'redirect':
      mp.redirectTo({ url: url });
      break;
    default:
      mp.navigateTo({ url: url });
  }
}

function addQeury(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var q = {};
  (0, _keys2.default)(query).forEach(function (name) {
    try {
      q[name] = btoa(query[name]);
    } catch (e) {
      q[name] = query[name];
    }
  });
  query = _queryString2.default.stringify(q);
  if (!query) {
    return url;
  }
  if (~url.indexOf('?')) {
    url = url.replace(/\?/, '?' + query + '&');
  } else {
    url = url + '?' + query;
  }
  return url;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/navigate/index.js
// module id = 854
// module chunks = 0